import { RichText } from "prismic-reactjs";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import adresses from "./data";
import "./index.scss";
import CrossBtn from "../../assets/close.png";
import { useEffect, useRef, useState } from "react";
import vf from "../../assets/covers/vf2";
import rock from "../../assets/covers/rock.js";
import rap from "../../assets/covers/rap";
import pop from "../../assets/covers/pop2";
import others from "../../assets/covers/others";
import geolocateIcon from "../../assets/img/geolocate.svg";
import gsap from "gsap";

const DisquairePage = ({ pageData, globalData }) => {
  const mapRef = useRef();
  const mapContainerRef = useRef();
  const [discInformations, setDiscInformations] = useState(null);
  const [geo, setGeo] = useState(null);

  const associations = {
    "rock-folk": rock,
    hiphop: rap,
    pop: pop,
    vf: vf,
    others: others,
  };

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoid2FybmVybXVzaWNmcmFuY2UiLCJhIjoiY2p0aWplZXd3MTRwZjQwbGhuNG12Mm0ybSJ9.LrneL3ZdUPgxBcBrg9FhQQ";

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [2.2137, 47.2276],
      zoom: 4.6,
      dragRotate: false,
      touchZoomRotate: false,
    });

    const geolocateControl = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
      showUserHeading: true,
    });

    setGeo(geolocateControl);
    mapRef.current.addControl(geolocateControl);

    adresses.forEach((address) => {
      const [lat, lng] = address.coordinates.split(", ").map(Number);
      new mapboxgl.Marker()
        .setLngLat([lng, lat])
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            `<h3>${address.name}</h3><p>${address.adress}, ${address.city}</p>`
          )
        )
        .addTo(mapRef.current);
    });

    return () => {
      mapRef.current.remove();
    };
  }, []);

  useEffect(() => {
    // gsap.from(".disquairePage .content", {
    //   opacity: 0,
    //   y: 50,
    //   duration: 1,
    //   ease: "power3.out",
    // });

    gsap.from(".disquairePage .ctas", {
      opacity: 0,
      y: 20,
      duration: 1,
      delay: 0.5,
      ease: "power3.out",
    });

    // gsap.from(".disquairePage .covers li", {
    //   opacity: 0,
    //   scale: 1,
    //   stagger: 0.2,
    //   duration: 0.8,
    //   delay: 1,
    //   ease: "back.out(1.7)",
    // });
  }, []);

  // useEffect(() => {
  //   if (discInformations !== null) {
  //     gsap.fromTo(
  //       ".discInformations",
  //       { opacity: 0, scale: 0.8 },
  //       { opacity: 1, scale: 1, duration: 0.5, ease: "power3.out" }
  //     );
  //   }
  // }, [discInformations]);

  if (globalData) {
    return (
      <section className="disquairePage">
        <div className="content">
          {pageData?.trouvetondisquairetext && (
            <div className="mb-30">
              <h1
                style={{
                  color: globalData.maintextcolor,
                }}
              >
                <RichText
                  className=""
                  render={pageData.trouvetondisquairetext}
                />
              </h1>
            </div>
          )}
          <div className="ctas">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const input = e.target.querySelector("input").value;
                fetch(`https://api.zippopotam.us/fr/${input}`)
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error("Invalid postal code");
                    }
                    return response.json();
                  })
                  .then((data) => {
                    const { longitude, latitude } = data.places[0];
                    mapRef.current.flyTo({
                      center: [parseFloat(longitude), parseFloat(latitude)],
                      zoom: 12,
                    });
                  })
                  .catch((error) => {
                    console.error(error);
                    gsap.to("form", {
                      duration: 0.06,
                      x: -10,
                      repeat: 5,
                      yoyo: true,
                    });
                  });
              }}
            >
              <input
                className="zipcode"
                placeholder="Mon code postal..."
                type="text"
              />
              <button type="submit">Rechercher</button>
            </form>
            <button
              onClick={() => {
                geo.trigger();
              }}
              className="geolocate"
            >
              <img src={geolocateIcon} alt="" />
            </button>
          </div>
        </div>

        <div id="map-container" ref={mapContainerRef} />

        {pageData?.textselectioncomplete && (
          <div className="mb-30 mt-30">
            <h1
              style={{
                color: globalData.maintextcolor,
              }}
            >
              <RichText
                className="mb-30"
                render={pageData.textselectioncomplete}
              />
            </h1>
          </div>
        )}

        <ul className="covers">
          {associations[pageData.path[0].text].map((el) => (
            <li onClick={() => setDiscInformations(el)}>
              <img src={el.ref[0]} alt="cover" />
              {pageData.path[0].text !== "vf" ? <h2>{el.artist}</h2> : <></>}
              <h3>{el.title}</h3>
              {/* <h3>{el.name}</h3> */}
              <button>Voir</button>
            </li>
          ))}
        </ul>

        {discInformations !== null && (
          <div className="discInformations">
            <div className="discInformationsOverlayContent">
              <div className="cross" onClick={() => setDiscInformations(null)}>
                <img className="CrossBtn" src={CrossBtn} alt="" />
              </div>
              <img
                src={
                  discInformations.ref.length > 1
                    ? discInformations.ref[1]
                    : discInformations.ref[0]
                }
                alt="cover"
              />
              <h2>{discInformations.artist}</h2>
              {discInformations.name?.length > 0 && (
                <h3>{discInformations.name}</h3>
              )}
              <p>{discInformations.type}</p>
              <p>{discInformations.label}</p>
              <p
                style={{
                  color: globalData.maintextcolor,
                }}
              >
                {discInformations.description}
              </p>
            </div>
            <div
              className="discInformationsOverlay"
              onClick={() => setDiscInformations(null)}
            ></div>
          </div>
        )}
      </section>
    );
  }
};

export default DisquairePage;
